export function countEventsByHour(timestamps) {
  // Create an array of 24 elements, initialized to 0
  const hours = Array(24).fill(0);

  timestamps.forEach((timestamp) => {
    const date = new Date(timestamp);
    const hour = date.getHours(); // Get the hour part of the timestamp
    hours[hour]++; // Increment the corresponding hour index
  });

  return hours;
}

// Function to convert UNIX time to a readable date-time format
export function formatUnixTime(unixTime) {
  const date = new Date(unixTime * 1000); // Convert to milliseconds
  return date.toLocaleString(); // Format as local date and time
}
